/** Last-resort React error boundary; prevents one module failure from breaking the whole DNN page. */
import { Component, type ErrorInfo, type PropsWithChildren, type ReactNode } from 'react';
import { readRuntimeUiLocale } from '../app/ui-locale';
import { publicCopy } from '../features/renderer/public-copy';

interface State { error?: Error }
export class ErrorBoundary extends Component<PropsWithChildren, State> {
  state: State = {};
  static getDerivedStateFromError(error: Error): State { return { error }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error('DynamicForms React error', error, info); }
  render(): ReactNode {
    if (this.state.error) { const copy = publicCopy(readRuntimeUiLocale()); return <div className="alert alert-danger"><h3>{copy.interfaceError}</h3><pre>{this.state.error.stack || this.state.error.message}</pre></div>; }
    return this.props.children;
  }
}
